import React from "react";
import DetailLayout from "../components/DetailLayout";
import InvigilationList from "../invigilationLog/invigilationList";

export default function PageSuperviseList() {
    return (
        <DetailLayout>
            <InvigilationList />
        </DetailLayout>
    );
}
